/**
 * Serviço para geração e exibição de QR Codes
 */

const TEMPLATE_HTML = `<!DOCTYPE html>
<html lang="pt-BR">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>QR Code PIX</title>
  <style>
    * { box-sizing: border-box; }
    body {
      margin: 0;
      padding: 20px;
      display: flex;
      justify-content: center;
      align-items: center;
      min-height: 100vh;
      background: linear-gradient(135deg, #1c2d5a 0%, #394774 100%);
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, sans-serif;
    }
    .container {
      background: white;
      padding: 40px;
      border-radius: 16px;
      box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
      text-align: center;
      max-width: 500px;
      width: 100%;
    }
    h2 {
      margin: 0 0 24px 0;
      color: #333;
      font-size: 24px;
      font-weight: 600;
    }
    .qrcode-wrapper {
      background: #f8f9fa;
      padding: 20px;
      border-radius: 12px;
      display: inline-block;
    }
    img {
      max-width: 300px;
      max-height: 300px;
      width: 100%;
      height: auto;
      border: 3px solid #e0e0e0;
      border-radius: 8px;
      display: block;
    }
    .info {
      margin-top: 24px;
      color: #666;
      font-size: 14px;
      line-height: 1.5;
    }
    @media print {
      body { background: white; }
      .container { box-shadow: none; }
    }
  </style>
</head>
<body>
  <div class="container">
    <h2>🔒 QR Code PIX</h2>
    <div class="qrcode-wrapper">
      <img src="{{QR_CODE_SRC}}" alt="QR Code PIX" />
    </div>
    <div class="info">
      Escaneie o QR Code com seu aplicativo de banco<br>
      para realizar o pagamento
    </div>
  </div>
</body>
</html>`

/**
 * Gera o HTML completo para exibição do QR Code
 * @param {string} qrcodeBase64 - String base64 da imagem do QR Code
 * @returns {string} HTML formatado com o QR Code
 */
function gerarHtmlQRCode(qrcodeBase64) {
  const imageSrc = `data:image/png;base64,${qrcodeBase64}`
  return TEMPLATE_HTML.replace('{{QR_CODE_SRC}}', imageSrc)
}

/**
 * Cria um blob URL a partir de HTML
 * @param {string} html - String HTML
 * @returns {string} Blob URL
 */
function criarBlobUrl(html) {
  const blob = new Blob([html], { type: 'text/html' })
  return URL.createObjectURL(blob)
}

/**
 * Abre o QR Code em uma nova janela do navegador
 * @param {string} qrcodeBase64 - String base64 da imagem do QR Code
 * @returns {Object} Resultado da operação { success: boolean, message?: string }
 */
export function abrirQRCode(qrcodeBase64) {
  if (!qrcodeBase64) {
    return {
      success: false,
      message: 'QR Code não disponível.'
    }
  }

  try {
    const html = gerarHtmlQRCode(qrcodeBase64)
    const url = criarBlobUrl(html)
    const novaJanela = window.open(url, '_blank')

    if (!novaJanela) {
      URL.revokeObjectURL(url)
      return {
        success: false,
        message: 'Permita pop-ups para visualizar o QR Code.'
      }
    }

    // Limpar o blob URL após 10 segundos para liberar memória
    setTimeout(() => URL.revokeObjectURL(url), 10000)

    return { success: true }
  } catch (error) {
    console.error('Erro ao gerar QR Code:', error)
    return {
      success: false,
      message: 'Erro ao gerar QR Code.'
    }
  }
}

export default {
  abrirQRCode
}
